import React from 'react';

export default () => (
  <div>
    <h3>Not found, or in progress ^_^</h3>
  </div>
);



// WEBPACK FOOTER //
// ./src/containers/NotFound/index.js